<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="value"
        transition="scale-transition"
        offset-y
        min-width="20px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="displayDate"
                :error-messages="errorMessages"
                :label="label"
                readonly
                :clearable="clearable"
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="date" no-title scrollable @input="update">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">{{ $t('Cancel') }}</v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
import { DateTime, formatDate } from '@/lib/helpers'

export default {
    props: {
        value: String,
        errorMessages: Array,
        label: String,
        clearable: Boolean,
    },
    data() {
        return {
            menu: false,
            date: {},
            displayDate: '',
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.date = value
            },
        },
        date: {
            immediate: true,
            handler(value) {
                this.myFormatDate(value)
                this.$emit('input', value)
            },
        },
        displayDate: {
            handler(value) {
                // Reset date when "clear" button is pressed so that it propagates
                if (null === value) {
                    this.date = ''
                }
            }
        },
        '$i18n.locale': function () {
            this.myFormatDate(this.date)
        },
    },
    methods: {
        myFormatDate(date) {
            if (!date) {
                this.displayDate = ''
            } else {
                this.displayDate = formatDate(DateTime.fromISO(date))
            }
        },
        update(event) {
            this.$refs.menu.save(event)
        },

    },
}
</script>

